import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    scrollContent: {
        justifyContent: "center",
        alignItems: "center"
    },
    marginContainer: {
        marginBottom: 20
    },
    editorScrollable: {
        minHeight: 350,
        width: "100%",
        height: 200
    },
    contentContainer: {
        maxWidth: 850,
        width: "100%"
    },
    editor: {
        minHeight: 350,
        width: "100%"
    },
    container: {
        flex: 1
    }
});
export default stylesheet;
